/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4-beta.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PartFromJSON(json) {
    return PartFromJSONTyped(json, false);
}
export function PartFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'partId': !exists(json, 'partId') ? undefined : json['partId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'partCode': !exists(json, 'partCode') ? undefined : json['partCode'],
        'partName': !exists(json, 'partName') ? undefined : json['partName'],
        'partType': !exists(json, 'partType') ? undefined : json['partType'],
        'costUnits': !exists(json, 'costUnits') ? undefined : json['costUnits'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'manufacturerPartCode': !exists(json, 'manufacturerPartCode') ? undefined : json['manufacturerPartCode'],
        'partUnitCost': !exists(json, 'partUnitCost') ? undefined : json['partUnitCost'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'accountCode': !exists(json, 'accountCode') ? undefined : json['accountCode'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'lastDateReconciled': !exists(json, 'lastDateReconciled') ? undefined : (new Date(json['lastDateReconciled'])),
        'vendorName': !exists(json, 'vendorName') ? undefined : json['vendorName'],
        'vendorPartCode': !exists(json, 'vendorPartCode') ? undefined : json['vendorPartCode'],
        'lastOrderDate': !exists(json, 'lastOrderDate') ? undefined : (new Date(json['lastOrderDate'])),
        'lastOrderQuantity': !exists(json, 'lastOrderQuantity') ? undefined : json['lastOrderQuantity'],
        'lastReqCode': !exists(json, 'lastReqCode') ? undefined : json['lastReqCode'],
        'requestQuantityInput': !exists(json, 'requestQuantityInput') ? undefined : json['requestQuantityInput'],
        'partAssetId': !exists(json, 'partAssetId') ? undefined : json['partAssetId'],
    };
}
export function PartToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'partId': value.partId,
        'propertyId': value.propertyId,
        'partCode': value.partCode,
        'partName': value.partName,
        'partType': value.partType,
        'costUnits': value.costUnits,
        'manufacturer': value.manufacturer,
        'manufacturerPartCode': value.manufacturerPartCode,
        'partUnitCost': value.partUnitCost,
        'notes': value.notes,
        'accountCode': value.accountCode,
        'jobType': value.jobType,
        'lastDateReconciled': value.lastDateReconciled === undefined ? undefined : (value.lastDateReconciled.toISOString()),
        'vendorName': value.vendorName,
        'vendorPartCode': value.vendorPartCode,
        'lastOrderDate': value.lastOrderDate === undefined ? undefined : (value.lastOrderDate.toISOString()),
        'lastOrderQuantity': value.lastOrderQuantity,
        'lastReqCode': value.lastReqCode,
        'requestQuantityInput': value.requestQuantityInput,
        'partAssetId': value.partAssetId,
    };
}
